import VerificationComponent from '../components/verification';

export default function Verification() {
  return <VerificationComponent />;
}
